import React from 'react';
import Field from './field';
import { debounce } from 'throttle-debounce';



class Form extends React.Component {
  state = {
    values: {},
    submitting: false,
    validated: false,
    errors: {},
    mounted: false, // ensure we complete mounting before displaying any fields
  };

  componentDidMount() {
    const newState = {
      ...this.state,
      mounted: true,
    };
    if (this.props.defaults) {
      // Toss the default values onto state, and everything else will just work
      newState.values = { ...this.props.defaults };
    }
    // console.log(this.props.defaults, 'the defaults');
    this.setState(newState);
  }

  // Expose reset functionality for after a form submission
  reset = () => {
    this.setState({
      values: {},
      submitting: false,
      validated: false,
      errors: {},
    });
  }

  updateValue = (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    // console.log('value', value);
    const fieldName = e.target.name;
    const field = this.props.form.fields[fieldName];
    const newState = {
      ...this.state,
      values: {
        ...this.state.values,
        [fieldName]: value,
      },
    };
    this.setState(newState);
    if (this.props.onUpdate) {
      this.props.onUpdate(newState.values);
    }
    // Optionally kick off validation
    // console.log('going to validate');
    this.optionallyValidateField(fieldName, field, value);
  }

  optionallyValidateField = debounce(200, (fieldName, field, value) => {
    if (this.state.validated) {
      // console.log("******** CALLING DEBOUNCED VALIDATE");
      this.validateField(field, value).then(result => {
        if (!result.valid) {
          this.setState({
            ...this.state,
            errors: {
              ...this.state.errors,
              [fieldName]: result.error,
            }
          });
        }
        else if (this.state.errors[fieldName]) {
          this.setState({
            ...this.state,
            errors: {
              ...this.state.errors,
              [fieldName]: undefined,
            }
          });
        }
      });
    }
  });

  setErrors = (errors) => {
    this.setState({
      ...this.state,
      validated: true,
      submitting: false,
      errors: errors,
    }, () => {
      const errorElements = document.getElementsByClassName('fielderror');
      if (errorElements && errorElements.length) {
        const bodyCoords = document.body.getBoundingClientRect();
        const coords = errorElements[0].getBoundingClientRect();
        const offset = coords.top - bodyCoords.top;
        if (!isNaN(offset)) {
          window.scrollTo(0, Math.round(offset) - 80);
        }
      }
    });
  }

  validateField = (field, value) => {
    return new Promise(async (resolve) => {
      // console.log(field, value, 'about to validate');
      if (field.schema) {
        // console.log(field, value, 'has schema');
        await field.schema.validate(value).catch((err) => {
          // console.log(err, 'ERROR ERROR');
          resolve({ valid: false, error: this.toSentence(err.message) });
        });
      }
      if (field.customValidation) {
        // Will return a message, or null
        const customResult = field.customValidation(field, value, this.state.values);
        if (customResult) {
          resolve({ valid: false, error: this.toSentence(customResult) });
        }
      }
      resolve({ valid: true });
    });
  }

  toSentence = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1) + '.';
  }

  validateForm = () => {
    return new Promise(async (resolve) => {
      const { form } = this.props;
      const { fields, order } = form;
      const { values } = this.state;
      const errors = {};
      let valid = true;

      for (let i = 0; i < order.length; i++) {
        const fieldName = form.order[i];
        const field = fields[fieldName];
        const value = values[fieldName];
        // console.log('START validation ', fieldName);
        if (field.condition) {
          if (!field.condition(values)) {
            continue;
          }
        }
        let result = await this.validateField(field, value);
        if (!result.valid) {
          valid = false;
          errors[fieldName] = result.error;
        }
      }

      resolve({ valid, errors });
    });
  }

  submitForm = async (e) => {
    this.setState({
      ...this.state,
      submitting: true,
    });
    e.preventDefault();
    // console.log(this.state.values, 'submitting');
    let validation = await this.validateForm();

    // console.log(validation, 'validation');
    if (validation.valid) {
      this.setState({
        ...this.state,
        validated: true,
        errors: {},
      });
      // Ensure that we are ONLY sending values that are represented in the form itself!
      const values = {};
      const { form } = this.props;
      const { order, fields } = form;
      for (let i = 0; i < order.length; i++) {
        const fieldName = order[i];
        const value = this.state.values[fieldName];
        const field = fields[fieldName];
        if (field && field.condition) {
          if (!field.condition(this.state.values)) {
            continue;
          }
        }
        if (typeof value !== 'undefined') {
          values[fieldName] = value;
        }
      }

      this.props.submitForm(values, this.setErrors, this.reset);
    }
    else {
      this.setErrors(validation.errors);
    }

  }

  render() {
    const { form, title, footer } = this.props;
    const { values, errors, submitting, mounted } = this.state;
    const { fields, order } = form;

    if (!mounted) {
      return null;
    }

    // console.log(values, 'the values in form');
    // console.log(errors, 'errors');
    if (form && form.fields && form.order) {
      return (
        // <div className="flex flex-col bg-gray-800 rounded-lg p-8 w-full mt-10 md:mt-0">
        <div className="">
          {title && <h2 className="text-gray-700 text-lg font-medium title-font mb-5">{title}</h2>}
          <form onSubmit={this.submitForm}>
            {
              order.map((fieldName) => {
                if (fields[fieldName].condition) {
                  if (!fields[fieldName].condition(values)) {
                    return null;
                  }
                }
                return (
                  <Field
                    key={fieldName}
                    name={fieldName}
                    submitting={submitting}
                    field={fields[fieldName]}
                    value={values[fieldName]}
                    error={errors[fieldName]}
                    updateValue={this.updateValue}
                    submitForm={this.submitForm}
                  />
                );
              })
            }
          </form>
          {footer && <p className="text-xs text-gray-500 mt-2">{footer}</p>}
        </div>
      )
    }
    return null;
  }
};

export default Form;